/*
 * tt-bundle-remove.js
 * Fixes Recharge bundle remove buttons in the cart drawer and on the /cart page.
 *
 * A Recharge bundle is several cart line items sharing one `_rc_bundle` property.
 * The bundle "remove" control (snippets/cart-recharge-bundle-product.liquid) is a
 * plain <a> GET link to /cart/update, which the browser just follows — nothing is
 * removed and the drawer closes. The theme's <cart-remove-button> path can only
 * zero ONE line via /cart/change.js, which would orphan the rest of the bundle.
 *
 * This delegated handler POSTs ALL of the bundle's line keys to /cart/update.js in
 * a single request, then re-renders the cart sections using the theme's existing
 * CartItems / CartDrawerItems machinery. The <a href> remains a no-JS fallback.
 */
(function () {
	document.addEventListener('click', function (event) {
		const btn = event.target.closest('.bundle-remove-button');
		if (!btn) return;

		const keys = (btn.dataset.bundleKeys || '')
			.split(',')
			.map((k) => k.trim())
			.filter(Boolean);

		// No keys to work with — let the link's href fallback handle it.
		if (!keys.length) return;

		event.preventDefault();

		const cartItems =
			btn.closest('cart-drawer-items') || btn.closest('cart-items');

		const updates = {};
		keys.forEach((key) => {
			updates[key] = 0;
		});

		const sectionsToRender = cartItems ? cartItems.getSectionsToRender() : [];
		const cartDrawerEl = document.querySelector('cart-drawer');
		const mainCartItems =
			document.getElementById('main-cart-items') ||
			document.getElementById('CartDrawer-CartItems');

		if (cartDrawerEl) cartDrawerEl.classList.add('is-updating');
		if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

		const body = JSON.stringify({
			updates: updates,
			sections: sectionsToRender.map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => response.text())
			.then((state) => {
				const parsedState = JSON.parse(state);

				if (cartItems) {
					cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
				}
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');
				if (cartFooter)
					cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						'is-empty',
						parsedState.item_count === 0
					);

				sectionsToRender.forEach((section) => {
					const container = document.getElementById(section.id);
					if (!container) return;
					const elementToReplace =
						container.querySelector(section.selector) || container;
					elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});

				if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
				}
			})
			.catch((error) => {
				console.error('Bundle remove failed, falling back to link:', error);
				// Last-resort fallback so the user isn't stuck.
				const href = btn.getAttribute('href');
				if (href) window.location.href = href;
			})
			.finally(() => {
				if (cartDrawerEl) cartDrawerEl.classList.remove('is-updating');
				if (mainCartItems)
					mainCartItems.classList.remove('cart__items--disabled');
			});
	});
})();
